module.exports = __webpack_public_path__ + "static/media/svco.dd3ecdcf.svg";